import { PickListItem, JsonItem, PickListItemSorted, RevamppVirusTarget } from "../list-management.objects"; 
import { DropdownGroup } from "../list-management.filters";
import { SpecialCaseEntity } from "../list-management.form-sections";
import _ from "lodash";

export class DeliverableTrlDropdown implements SpecialCaseEntity {
    id: string;
    propertyName: string;
    displayName: string;
    description: string;
    isNew: boolean;

    trlPickListName: string;
    trlPickList: PickListItemSorted[] = [];
    categoryDropdownId: string; // Id for the dropdown showing the associated center (show/hide based on category)

    storedValues: number[] = [];
    initialValue: number;

    constructor(id: string, propteryName: string, trlPickListName: string, displayName: string, description: string, categoryDropdownId: string, isNew: boolean = false) {
        this.id = id;
        this.propertyName = propteryName;
        this.displayName = displayName;
        this.description = description;
        this.categoryDropdownId = categoryDropdownId;
        this.isNew = isNew;

        this.trlPickListName = trlPickListName;
    }

    generateHtml(): string {
        let size = "";
        if (this.isNew) {
            size = "col-lg-5"
        }

        let html = `
            <div id="${this.id}-container" class="mb-3 col-12 ${size} px-0 deliverables-trl-select-container">
                <label class="required">${this.displayName}</label>
                <span class="pl-2">
                    <a tabindex="0" id="${this.id}-help-btn" class="" role="button" data-toggle="popover" data-trigger="focus"><i class="fa-solid fa-circle-info"></i></a>
                </span>
                ${this.description != "" ? `<p class='form-text mb-1 mt-0'>${this.description}</p>` : ``}
                <select id="${this.id}" class="selectpicker dropdown list-management-dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5" data-live-search="true"></select>
            </div>
        `;
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        // Create Lists
        this.trlPickList = [];
        let foundList = pickLists.find(list => list.Id == this.trlPickListName)?.Json;

        if (!foundList) return;

        this.trlPickList = foundList;

        this.generateDropdown(`${this.id}`);

        $(`#${this.categoryDropdownId}`).off("changed.bs.select").on("changed.bs.select", () => {
            this.updateDropdownVisibility();
        });

        this.updateDropdownVisibility();

        this.initialValue = undefined;

        let targetContainer = `.edit-section-container`;
        let popoverClass = "deliverables-trl-popover edit-deliverables-popover"

        if (this.isNew) {
            targetContainer = `#${this.id}-container`;
            popoverClass = "deliverables-trl-popover"
        }


        $(`#${this.id}-help-btn`).popover({
            trigger: 'focus',
            html: true,
            content: () => {
                let templateEl = document.querySelector("#deliverables-trl-info");
                let content = templateEl.innerHTML;
                return content;
            },
            container: targetContainer,
            customClass: popoverClass
        })
    }

    updateDropdownVisibility(): void {
        let val = $(`#${this.categoryDropdownId}`).val();
        switch (val) {
            case "1": // Vaccine
                $(`#${this.id}-container`).removeClass("d-none")
                break;
            case "2": // Antibody
                $(`#${this.id}-container`).removeClass("d-none")
                break;
            default: // Knowledge or Coordination
                $(`#${this.id}`).selectpicker("val", "0");
                $(`#${this.id}-container`).addClass("d-none")
                break;
        }
    }

    getValue(): any {
        let stringVal = <string>$(`#${this.id}`).val();
        let parsedNum = parseInt(stringVal);
        if (!parsedNum) {
            return 0;
        }
        return parsedNum;
    }

    validate(): boolean {
        if ($(`#${this.id}`).siblings(".dropdown-toggle").is(":visible")) {
            if (this.getValue() != 0) {
                this.displayValid(true);
                return true;
            }
            else {
                this.displayValid(false);
                return false;
            }
        }
        else {
            this.displayValid(true);
            return true;
        }
    }

    displayValid(isValid: boolean): void {
        if (isValid) {
            $(`#${this.id}`).siblings(".dropdown-toggle").addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
        }
    }

    getDisplayTrl(trlId: number): string {
        let returnVal = "";
        let foundTrl = this.trlPickList.find(item => item.Id == trlId);
        if (foundTrl) {
            returnVal = foundTrl.Value;
        }
        return returnVal;
    }

    updateStoredValues(entityArray: any[]): void {
        this.storedValues = [];
        entityArray.forEach(entity => {
            this.storedValues.push(_.get(entity, this.propertyName));
        })

        if (this.storedValues.every((val, i, arr) => val == arr[0]) && this.storedValues.length > 0) {
            this.populateField(this.storedValues[0]);
        }

        if (this.initialValue == undefined) {
            if (this.storedValues.every((val, i, arr) => val == arr[0]) && this.storedValues.length > 0) {
                this.initialValue = this.storedValues[0];
            }
            else {
                this.initialValue = 0;
            }
        }
    }

    populateField(value): void {
        $(`#${this.id}`).selectpicker("val", value);
    }

    checkChanged(): boolean {
        if (this.getValue() != this.initialValue) {
            return true;
        }
        else {
            return false;
        }
    }

    // TRL Levels
    generateDropdown(dropdownId: string): void {
        // Remove any previous options
        $(`#${dropdownId}`).find("option").remove();

        $(`#${dropdownId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        this.trlPickList.sort((x1, x2) => x1.SortOrder - x2.SortOrder);
        this.trlPickList.forEach((item: PickListItemSorted) => {
            $(`#${dropdownId}`).append(new Option(item.Value, item.Id.toString(), false, false));
        });

        $(`#${dropdownId}`).selectpicker("refresh");
    }

    getPreviousDisplayValue(index): string {
        let foundValueId = this.storedValues[index];
        if (foundValueId) {
            return this.getDisplayTrl(foundValueId);
        }
        else {
            return "";
        }
    }

    getCurrentDisplayValue(): string {
        let foundValueId = this.getValue();
        if (foundValueId) {
            return this.getDisplayTrl(foundValueId);
        }
        else {
            return "";
        }
    }
}

export class DeliverableSubcategorySelection implements SpecialCaseEntity {
    id: string;
    propertyName: string;
    displayName: string;
    description: string;
    isRequired: boolean;
    isNew: boolean;

    categoryDropdownId: string;

    vaccineListName: string;
    vaccinePickList: PickListItemSorted[];
    antibodyListName: string;
    antibodyPickList: PickListItemSorted[];
    knowledgeListName: string;
    knowledgePickList: PickListItemSorted[];
    coordinationListName: string;
    coordinationPickList: PickListItemSorted[];

    currentSubcategoryList: PickListItemSorted[];

    storedValues: string[] = [];
    initialValue: string;

    constructor(id: string, propteryName: string, pickListNameArr: string[], displayName: string, description: string, categoryDropdownId: string, isRequired: boolean = true, isNew: boolean = false) {
        this.id = id;
        this.propertyName = propteryName;
        this.displayName = displayName;
        this.description = description;
        this.categoryDropdownId = categoryDropdownId;
        this.isRequired = isRequired;
        this.isNew = isNew;

        let vaccinePickListName = pickListNameArr.find(name => name.includes("vaccine"));
        if (vaccinePickListName) this.vaccineListName = vaccinePickListName;
        let antibodyPickListName = pickListNameArr.find(name => name.includes("antibody"));
        if (antibodyPickListName) this.antibodyListName = antibodyPickListName;
        let knowledgePickListName = pickListNameArr.find(name => name.includes("knowledge"));
        if (knowledgePickListName) this.knowledgeListName = knowledgePickListName;
        let coordPickListName = pickListNameArr.find(name => name.includes("coord"));
        if (coordPickListName) this.coordinationListName = coordPickListName;
    }

    generateHtml(): string {
        let requiredClass = ""
        if (this.isRequired) requiredClass = "required"
        let size = "";
        if (this.isNew) size = "col-lg-5";

        let html = `
            <div id="${this.id}-container" class="mb-3 col-12 ${size} px-0">
                <label for="" class="${requiredClass}">${this.displayName}</label>
                ${this.description != "" ? `<p class='form-text mt-0'>${this.description}</p>` : ``}
                <p class='form-text mb-1 mt-0'>Select all that apply.</p>
                <select id="${this.id}" class="selectpicker dropdown list-management-dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5" multiple></select>
            </div>
        `;
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        // Create Lists
        this.vaccinePickList = [];
        let foundList = pickLists.find(list => list.Id == this.vaccineListName)?.Json;
        if (foundList) this.vaccinePickList = foundList;

        this.antibodyPickList = [];
        foundList = pickLists.find(list => list.Id == this.antibodyListName)?.Json;
        if (foundList) this.antibodyPickList = foundList;

        this.knowledgePickList = [];
        foundList = pickLists.find(list => list.Id == this.knowledgeListName)?.Json;
        if (foundList) this.knowledgePickList = foundList;

        this.coordinationPickList = [];
        foundList = pickLists.find(list => list.Id == this.coordinationListName)?.Json;
        if (foundList) this.coordinationPickList = foundList;

        if (this.vaccinePickList.length == 0 && this.antibodyPickList.length == 0 && this.knowledgePickList.length == 0 && this.coordinationPickList.length == 0) return;

        this.updateCurrentSubcategoryList();

        this.generateDropdown(`${this.id}`);

        this.initialValue = undefined;
    }

    updateCurrentSubcategoryList(): void {
        let categoryVal = $(`#${this.categoryDropdownId}`).val();
        if (!categoryVal) {
            this.currentSubcategoryList = [];
            return;
        }

        switch (categoryVal) {
            case "1":
                this.currentSubcategoryList = this.vaccinePickList;
                break;
            case "2":
                this.currentSubcategoryList = this.antibodyPickList;
                break;
            case "3":
                this.currentSubcategoryList = this.knowledgePickList;
                break;
            case "4":
                this.currentSubcategoryList = this.coordinationPickList;
                break;
            default:
                this.currentSubcategoryList = [];
                break;
        }
    }

    // Subcategories
    generateDropdown(dropdownId: string): void {
        // Remove any previous options
        $(`#${dropdownId}`).find("option").remove();

        $(`#${dropdownId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        this.currentSubcategoryList.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
        this.currentSubcategoryList.forEach((item: PickListItemSorted) => {
            $(`#${dropdownId}`).append(new Option(item.Value, item.Id.toString(), false, false));
        });

        $(`#${dropdownId}`).selectpicker("refresh");
    }

    getValue(): any {
        return (<string[]>$(`#${this.id}`).val())?.join("|");
    }

    validate(): boolean {
        if (!this.isRequired) {
            this.displayValid(true);
            return true;
        }
        else {
            if (this.getValue() != "") {
                this.displayValid(true);
                return true;
            }
            else {
                this.displayValid(false);
                return false;
            }
        }
    }

    displayValid(isValid: boolean): void {
        if (isValid) {
            $(`#${this.id}`).siblings(".dropdown-toggle").addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
        }
    }

    getDisplaySubcategory(subcategoryIds: string): string {
        let subcategoryIdArr = subcategoryIds.split("|");
        let returnValArr = [];
        subcategoryIdArr.forEach(subcatId => {
            let foundSubcat = this.currentSubcategoryList.find(item => item.Id.toString() == subcatId);
            if (foundSubcat) returnValArr.push(foundSubcat.Value);
        })

        returnValArr.sort();
        return returnValArr.join("<br>");
    }

    updateStoredValues(entityArray: any[]): void {
        this.storedValues = [];
        entityArray.forEach(entity => {
            this.storedValues.push(_.get(entity, this.propertyName));
        })

        if (this.storedValues.every((val, i, arr) => val == arr[0]) && this.storedValues.length > 0) {
            this.populateField(this.storedValues[0]);
        }

        if (this.initialValue == undefined) {
            if (this.storedValues.every((val, i, arr) => val == arr[0]) && this.storedValues.length > 0) {
                this.initialValue = this.storedValues[0];
            }
            else {
                this.initialValue = "";
            }
        }
    }

    populateField(subcategoryIds: string): void {
        let optionArr = subcategoryIds?.split("|");
        $(`#${this.id}`).selectpicker("val", optionArr);
    }

    checkChanged(): boolean {
        if (this.getValue() != this.initialValue) {
            return true;
        }
        else {
            return false;
        }
    }

    getPreviousDisplayValue(index: number): string {
        let foundValueId = this.storedValues[index];
        if (foundValueId) {
            return this.getDisplaySubcategory(foundValueId);
        }
        else {
            return "";
        }
    }

    getCurrentDisplayValue(): string {
        let foundValueId = this.getValue();
        if (foundValueId) {
            return this.getDisplaySubcategory(foundValueId);
        }
        else {
            return "";
        }
    }
}

export class DeliverableStageSelection implements SpecialCaseEntity {
    id: string;
    propertyName: string;
    displayName: string;
    description: string;
    isRequired: boolean;
    isNew: boolean;

    categoryDropdownId: string;

    vaccineListName: string;
    vaccinePickList: PickListItemSorted[];
    antibodyListName: string;
    antibodyPickList: PickListItemSorted[];
    knowledgeListName: string;
    knowledgePickList: PickListItemSorted[];
    coordinationListName: string;
    coordinationPickList: PickListItemSorted[];

    currentStageList: PickListItemSorted[];

    storedValues: number[] = [];
    initialValue: number;

    constructor(id: string, propteryName: string, pickListNameArr: string[], displayName: string, description: string, categoryDropdownId: string, isRequired: boolean = true, isNew: boolean = false) {
        this.id = id;
        this.propertyName = propteryName;
        this.displayName = displayName;
        this.description = description;
        this.categoryDropdownId = categoryDropdownId;
        this.isRequired = isRequired;
        this.isNew = isNew;

        let vaccinePickListName = pickListNameArr.find(name => name.includes("vaccine"));
        if (vaccinePickListName) this.vaccineListName = vaccinePickListName;
        let antibodyPickListName = pickListNameArr.find(name => name.includes("antibody"));
        if (antibodyPickListName) this.antibodyListName = antibodyPickListName;
        let knowledgePickListName = pickListNameArr.find(name => name.includes("knowledge"));
        if (knowledgePickListName) this.knowledgeListName = knowledgePickListName;
        let coordPickListName = pickListNameArr.find(name => name.includes("coord"));
        if (coordPickListName) this.coordinationListName = coordPickListName;
    }

    generateHtml(): string {
        let requiredClass = ""
        if (this.isRequired) requiredClass = "required";
        let size = "";
        if (this.isNew) size = "col-lg-5";

        let html = `
            <div id="${this.id}-container" class="mb-3 col-12 ${size} px-0">
                <label for="" class="${requiredClass}">${this.displayName}</label>
                ${this.description != "" ? `<p class='form-text mt-0'>${this.description}</p>` : ``}
                <p class='form-text mb-1 mt-0'>Select all that apply.</p>
                <select id="${this.id}" class="selectpicker dropdown list-management-dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5"></select>
            </div>
        `;
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        // Create Lists
        this.vaccinePickList = [];
        let foundList = pickLists.find(list => list.Id == this.vaccineListName)?.Json;
        if (foundList) this.vaccinePickList = foundList;

        this.antibodyPickList = [];
        foundList = pickLists.find(list => list.Id == this.antibodyListName)?.Json;
        if (foundList) this.antibodyPickList = foundList;

        this.knowledgePickList = [];
        foundList = pickLists.find(list => list.Id == this.knowledgeListName)?.Json;
        if (foundList) this.knowledgePickList = foundList;

        this.coordinationPickList = [];
        foundList = pickLists.find(list => list.Id == this.coordinationListName)?.Json;
        if (foundList) this.coordinationPickList = foundList;

        if (this.vaccinePickList.length == 0 && this.antibodyPickList.length == 0 && this.knowledgePickList.length == 0 && this.coordinationPickList.length == 0) return;

        this.updateCurrentStageList();

        this.generateDropdown(`${this.id}`);

        this.initialValue = undefined;
    }

    updateCurrentStageList(): void {
        let categoryVal = $(`#${this.categoryDropdownId}`).val();
        if (!categoryVal) {
            this.currentStageList = [];
            return;
        }

        switch (categoryVal) {
            case "1":
                this.currentStageList = this.vaccinePickList;
                break;
            case "2":
                this.currentStageList = this.antibodyPickList;
                break;
            case "3":
                this.currentStageList = this.knowledgePickList;
                break;
            case "4":
                this.currentStageList = this.coordinationPickList;
                break;
            default:
                this.currentStageList = [];
                break;
        }
    }

    // Stage
    generateDropdown(dropdownId: string): void {
        // Remove any previous options
        $(`#${dropdownId}`).find("option").remove();

        $(`#${dropdownId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        this.currentStageList.sort((x1, x2) => x1.SortOrder - x2.SortOrder);
        this.currentStageList.forEach((item: PickListItemSorted) => {
            $(`#${dropdownId}`).append(new Option(item.Value, item.Id.toString(), false, false));
        });

        $(`#${dropdownId}`).selectpicker("refresh");
    }

    getValue(): any {
        let stringVal = <string>$(`#${this.id}`).val();
        let parsedNum = parseInt(stringVal);
        if (!parsedNum) {
            return 0;
        }
        return parsedNum;
    }

    validate(): boolean {
        if (!this.isRequired) {
            this.displayValid(true);
            return true;
        }
        else {
            if (this.getValue() != 0) {
                this.displayValid(true);
                return true;
            }
            else {
                this.displayValid(false);
                return false;
            }
        }
    }

    displayValid(isValid: boolean): void {
        if (isValid) {
            $(`#${this.id}`).siblings(".dropdown-toggle").addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
        }
    }

    getDisplayStage(stageId: number): string {
        let returnVal = "";
        let foundStage = this.currentStageList.find(item => item.Id == stageId);
        if (foundStage) {
            returnVal = foundStage.Value;
        }
        return returnVal;
    }

    updateStoredValues(entityArray: any[]): void {
        this.storedValues = [];
        entityArray.forEach(entity => {
            this.storedValues.push(_.get(entity, this.propertyName));
        })

        if (this.storedValues.every((val, i, arr) => val == arr[0]) && this.storedValues.length > 0) {
            this.populateField(this.storedValues[0]);
        }

        if (this.initialValue == undefined) {
            if (this.storedValues.every((val, i, arr) => val == arr[0]) && this.storedValues.length > 0) {
                this.initialValue = this.storedValues[0];
            }
            else {
                this.initialValue = 0;
            }
        }
    }

    populateField(stageId: number): void {
        $(`#${this.id}`).selectpicker("val", stageId.toString());
    }

    checkChanged(): boolean {
        if (this.getValue() != this.initialValue) {
            return true;
        }
        else {
            return false;
        }
    }

    getPreviousDisplayValue(index: number): string {
        let foundValueId = this.storedValues[index];
        if (foundValueId) {
            return this.getDisplayStage(foundValueId);
        }
        else {
            return "";
        }
    }

    getCurrentDisplayValue(): string {
        let foundValueId = this.getValue();
        if (foundValueId) {
            return this.getDisplayStage(foundValueId);
        }
        else {
            return "";
        }
    }
}